import { Autocomplete, AutocompleteProps } from '@mui/material';
import { forwardRef, Ref } from 'react';

interface Props<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
> extends AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> {}

const MBAutocomplete = <
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
>(
  { sx, ...other }: Props<T, Multiple, DisableClearable, FreeSolo>,
  ref: Ref<any>
) => {
  return (
    <Autocomplete ref={ref} sx={{ width: '100%', ...(sx || {}) }} {...other} />
  );
};

export default forwardRef(MBAutocomplete);
